export default __webpack_public_path__ + "static/media/team18.b7282615.JPG";